import { defineMessages } from 'react-intl';

export default defineMessages({
  titleMessage: {
    id: 'app.components.skiplink',
    defaultMessage: 'Ir al contenido principal',
  },
});
